// Pure validation + preview formatting for the wallet-adjustment dialog
// (phase-2 Slice W, task W2). Kept side-effect-free so it's testable without
// React — see adjustmentRules.test.js. Mirrors the server's own rejections
// (functions/adjustWallet.js, task W1) so the dialog's submit button
// disables before a doomed call ever reaches the callable.

export const MAX_ABS_DELTA = 100;
export const MAX_REASON = 1000;

// The server (functions/adjustWallet.js) round2's the delta BEFORE checking
// it against zero/the limit, not after — so a raw 0.004 (which looks
// non-zero) is checked as the 0 it rounds to, and a raw 100.001 (which looks
// over the limit) is checked as the 100 it rounds to. Round here first, in
// the same order, or the client and server disagree at those boundaries.
const round2 = (n) => Math.round(n * 100) / 100;

export const validateAdjustment = ({ delta, reason }) => {
  const numDelta = round2(Number(delta));
  const trimmedReason = (reason || "").trim();

  if (!Number.isFinite(numDelta) || numDelta === 0) {
    return { valid: false, error: "Enter a non-zero amount." };
  }
  if (Math.abs(numDelta) > MAX_ABS_DELTA) {
    return {
      valid: false,
      error: `Amount must be ${MAX_ABS_DELTA} sessions or fewer.`,
    };
  }
  if (trimmedReason.length === 0) {
    return { valid: false, error: "Reason is required." };
  }
  if (trimmedReason.length > MAX_REASON) {
    return {
      valid: false,
      error: `Reason must be ${MAX_REASON} characters or fewer.`,
    };
  }
  return { valid: true, error: "" };
};

// "12.0 → 13.0 sessions" — one decimal on both sides, always. A missing/
// non-numeric currentBalance (a user doc with no WalletBalance yet) previews
// as 0, matching how the dialog treats an absent balance everywhere else.
export const formatPreview = ({ currentBalance, delta }) => {
  const from = Number(currentBalance) || 0;
  const numDelta = round2(Number(delta) || 0);
  const to = from + numDelta;
  return `${from.toFixed(1)} → ${to.toFixed(1)} sessions`;
};
